<template>
	<v-container
		class="container-height d-flex align-center justify-center"
		fluid
	>
		<div class="text-center">
			<v-progress-circular
				:size="isMobile ? 70 : 90"
				:width="isMobile ? 5 : 6"
				color="primary"
				indeterminate
			></v-progress-circular>
			<p class="text-center" :class="{ 'text-h5': isMobile, 'text-h4': !isMobile }">Cargando</p>
		</div>
	</v-container>
</template>

<script>
export default {
    props: {
        isMobile: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style scoped>
.container-height {
    height: calc(100vh - 240px);
}
</style>